import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Organisation } from '@principle-theorem/principle-core';
import {
  type IOrganisation,
  type IRole,
  isOrganisation,
} from '@principle-theorem/principle-core/interfaces';
import {
  getDoc,
  isWithRef,
  type ResolverResult,
  type WithRef,
} from '@principle-theorem/shared';
import { doc } from '@principle-theorem/shared';

@Injectable()
export class OrgRoleResolver {
  resolve(
    activatedRoute: ActivatedRouteSnapshot
  ): ResolverResult<WithRef<IRole>> {
    const uid: string = activatedRoute.paramMap.get('uid') || '';
    if (!activatedRoute.parent || !activatedRoute.parent.data.organisation) {
      throw new Error(`Can't find parent route`);
    }

    const organisation = activatedRoute.parent.data.organisation as unknown;
    if (
      !isOrganisation(organisation) ||
      !isWithRef<IOrganisation>(organisation)
    ) {
      throw new Error(`Can't find organisation`);
    }

    return getDoc(doc(Organisation.roleCol(organisation), uid));
  }
}
